
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import DateRange from '../../components/dateRangePicker/dateRange';
import DetailInvoice from '../../components/modals/invoiceDetailModal';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';


/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';



/*Assets*/


class InvoiceListing extends Component {
  constructor(props){
    super(props);
    this.state = {
      category: null,
      dateFilter: false,
      initalDate: moment().format(),
      startDate: moment().startOf('month'),
      endDate: moment(),
      apiLoading: false,
      data: null,
      pageNumActive: true,
      pageNumLoader: false,
      pageNum: 1
    }
  }

  componentDidMount() {
    this.getData(this.state.pageNum);
  }
   getData(tempPageNum){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'invoice/list';
    var data = JSON.stringify({
      "page_num": tempPageNum,
      "startDate": this.state.startDate,
      "endDate": this.state.endDate
    })
    APIPost(url, data).then(function(response){
      if(response.status === "ok"){
        if(response.data.length <= 39){
          this.setState({ pageNumActive: false});
        }
        else{
          this.setState({ pageNumActive: true});
        }

        if(this.state.data){
          var tempData = this.state.data;
          tempData.push(response.data);
          this.setState({ data: data, apiLoading: false, pageNumLoader: false});
        }
        else{
          this.setState({ data: response.data, apiLoading: false, pageNumLoader: false});
        }

      }
      else{
        this.setState({ apiLoading: false });
      }
    }.bind(this))
  }

  loadMore(){
    this.getData(this.state.pageNum + 1);
    this.setState({pageNum: this.state.pageNum + 1, pageNumLoader: true});
  }

  selectChange = async (category) => {
    this.setState({apiLoading: true});
    await this.setState({category: category});
    var url = devconfig.vendor+'invoice/list';
    var data = JSON.stringify({
      "page_num": 1,
      "start_date": this.state.tempStart,
      "end_date": this.state.tempEnd,
      "plan_id": category.value
    })
     APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        console.log(data)
        this.setState({ data: response.data,apiLoading: false});
      }
    }.bind(this))

  }


  dateChange(tempStart, tempEnd){
    this.setState({tempStart,tempEnd});
    var url = devconfig.vendor+'invoice/list';
    var data = JSON.stringify({
      "page_num": 1,
      "start_date": tempStart,
      "end_date": tempEnd
    })
     APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        console.log(data)
        this.setState({ data: response.data});
      }
    }.bind(this))

  }

  render() {

    const filterBy = [
      { value: 1, label: 'Basic' },
      { value: 2, label: 'Sliver' },
      { value: 3, label: 'Gold' },
    ]

    return (
      <div>
        {
          this.state.apiLoading ?
            <APILoader/>
            :
              <div className="e-main-content e-vendor-table e-scheduled-ads-wrap e-buisness-list">
                <h2 className="e-page-head">Invoices</h2>
                <div className="row">
                  <div className="col-lg-3">
                    <h6>Filter by</h6>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-lg-3">
                    <DateRange dateChange={this.dateChange.bind(this)} isOutsideRange={true}/>
                  </div>
                  {/*<div className="col-lg-2">
                    <SelectBox defaultValue={this.state.filterDefault} options={filterBy} selectchange={this.selectChange} placeholder="Filter by Plan"/>
                  </div>*/}
                </div>
                {
                  this.state.data && this.state.data.length ?
                    <div>
                      <div className="row">
                        {
                          this.state.data.map((item,index) => {
                            var tempId = "e-invoice-modal"+item.id;
                            var tempSelector = "#e-invoice-modal"+item.id;
                            return(

                              <div className="col-lg-10 col-md-12 col-sm-12 col-12 mb-4" key={index}>
                                <div className="e-vendor-category-list">
                                  <div className="row">
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-6">
                                      <h6>Plan type</h6>
                                      <p className="mb-0">{item.type}</p>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-6">
                                      <h6>Plan name</h6>
                                      <p className="mb-0">{item.plan_name}</p>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-6">
                                      <h6>Purchased on</h6>
                                      <p className="mb-0">{item.purchased_on}</p>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-6 mt-md-0 mt-lg-0 mt-sm-3 mt-col-3">
                                      <h6>Total amount</h6>
                                      <p className="mb-0">INR {item.total}/-</p>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-6 mt-md-0 mt-lg-0 mt-sm-3 mt-col-3">
                                      <h6>Status</h6>
                                      <p className="mb-0 c-success">{item.status}</p>
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-6mt-md-0 mt-lg-0 mt-sm-3 mt-col-3">
                                      <h6>Action</h6>
                                      <a href="#" data-toggle="modal" data-target={tempSelector}>View detail</a>
                                      <DetailInvoice id={item.id} selector={tempId}/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        }

                      </div>

                      {
                      this.state.pageNumActive ?
                        <div className="text-center">
                          {
                            this.state.pageNumLoader ?
                              <APILoader/>
                            :
                              <button className="e-s-btn-2" onClick={this.loadMore.bind(this)}>Load More</button>
                          }
                        </div>
                      :
                        null
                    }
                  </div>
                :
                <NoDataFound data="No invoices found"/>
            }
          </div>
        }

      </div>
    );
  }
}

export default InvoiceListing;
